import React, { useState } from 'react';

import {
  CONFIRMATION_MODAL,
  MEDICATION_ACTION_TYPES,
  MEDICATION_STATUS
} from 'components/shared/Forms/Custom/ProviderMedications/lib/constants';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

import { onHandleDelete } from '../lib/handleNonERXMedicationDelete';
import { onHandleUpdateStatus } from '../lib/handleNonERXMedicationUpdateStatus';

const Actions = ({ data, customProps }) => {
  const [confirmationModal, setConfirmationModal] = useState(CONFIRMATION_MODAL);

  const handleStatusLabel = data?.status === MEDICATION_STATUS.ACTIVE ? 'inactive' : 'active';

  const options = [
    {
      icon: 'edit-2-linear',
      label: 'Edit',
      onClick: () => customProps?.setShowMedicationModal({ open: true, data })
    },
    {
      icon: 'trash-mono',
      label: 'Delete',
      onClick: () => setConfirmationModal({ open: true, type: MEDICATION_ACTION_TYPES.DELETE })
    },
    {
      icon: 'status-mono',
      color: data?.status === MEDICATION_STATUS.ACTIVE ? 'danger' : 'primary',
      stroke: true,
      label: `Mark ${handleStatusLabel}`,
      onClick: () =>
        setConfirmationModal({ open: true, type: MEDICATION_ACTION_TYPES.UPDATE_STATUS })
    }
  ];

  return (
    <div className="flex h-full w-full items-center justify-center">
      <Popover
        options={options}
        optionIconColor="primary"
        position="left"
        isFixed
        icon="context-menu-vertical"
      />

      {confirmationModal?.open && confirmationModal?.type === MEDICATION_ACTION_TYPES.DELETE && (
        <Confirm
          icon="info-filled"
          iconColor="danger"
          iconSize={42}
          variant="danger"
          primaryBtnTxt="Delete"
          title="Delete Medication"
          message={`Are you sure you want to delete this medication? ${data?.id ? "Deleting it here will remove it from all the patient's records." : ''}`}
          handleContinue={() =>
            onHandleDelete({
              formik: customProps?.formik,
              data,
              setConfirmationModal
            })
          }
          handleOpen={!!confirmationModal?.open}
          handleClose={() => setConfirmationModal(CONFIRMATION_MODAL)}
        />
      )}

      {confirmationModal?.open &&
        confirmationModal?.type === MEDICATION_ACTION_TYPES.UPDATE_STATUS && (
          <Confirm
            icon="info-filled"
            iconSize={42}
            variant="warning"
            primaryBtnTxt={`Mark ${handleStatusLabel}`}
            title={`Mark ${handleStatusLabel} Medication`}
            message={`Are you sure you want to mark this medication as ${handleStatusLabel}?`}
            handleContinue={() =>
              onHandleUpdateStatus({
                formik: customProps?.formik,
                data,
                setConfirmationModal,
                handleStatusLabel
              })
            }
            handleOpen={!!confirmationModal?.open}
            handleClose={() => setConfirmationModal(CONFIRMATION_MODAL)}
          />
        )}
    </div>
  );
};

export default Actions;
